'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/review-renderer.js';
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _themes = require('@marmalade/themes');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var slideStyles = function slideStyles(_ref) {
  var theme = _ref.theme;
  return _defineProperty({
    padding: '0 ' + theme.space_sm + ' ' + theme.space_sm,
    '> h3': {
      color: theme.colorPrimary
    },
    '> p': {
      color: theme.colorGrey
    }
  }, (0, _themes.atLeast)(theme.breakpoint_md), {
    padding: '0 ' + theme.space_lg + ' ' + theme.space_sm
  });
};

/* eslint-disable react/prop-types */

var ReviewRenderer = function ReviewRenderer(slides) {
  return function (props) {
    var key = props.key,
      index = props.index;
    var slideIndex = index % slides.length;
    var slide = slides[slideIndex < 0 ? Math.abs(slideIndex + slides.length) : slideIndex];
    var Slide = (0, _glamorous2.default)('div')(slideStyles);
    return _react2.default.createElement(Slide, {
      key: key,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 26
      },
      __self: undefined
    }, _react2.default.createElement('h3', {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 27
      },
      __self: undefined
    }, slide.title), _react2.default.createElement('p', {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 28
      },
      __self: undefined
    }, slide.body));
  };
};
exports.default = ReviewRenderer;